import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useStyles } from './FieldFile.styles'

type Props = {
  name: string
  required?: boolean
}
const FieldFile: React.FC<Props> = ({
  name,
  children,
  required
}) => {
  const classes = useStyles()

  return (
    <Box className={classes.field}>
      {children}
      <input
        className={classes.inputFile}
        type="file"
        name={name}
        id={name}
        accept=".pdf"
        required={required}
      />
      <Typography
        variant="caption"
        component="p"
        className={classes.legend}
      >
        Arquivo em formato PDF. Tamanho máximo de até 5MB.
      </Typography>
    </Box>
  )
}

export default FieldFile
